import { FC } from "react"
import * as React from "react"
import cx from "classnames"
import Link from "gatsby-link"

import * as styles from "./styles.module.scss"

export interface BackProps {
  backLink: string
  bare: boolean
}

const Back: FC<BackProps> = ({ backLink, bare }) => {
  return (
    <Link className={styles.back} to={`${backLink}${bare ? "?bare=true" : ""}`}>
      <i
        className={cx({
          [styles.arrow]: true,
          ["bsk-icon-arrow-stick-left-thick"]: true,
        })}
      />
      <span className={styles.text}>Frequently asked questions</span>
    </Link>
  )
}

export default Back
